import styles from './BannerModule.module.scss';

import cx from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { toEntry, AppType, Link, WithCMS } from 'services/cms/typesUtil';
import { ButtonLinkV2 } from '../Button/ButtonLinkV2';
import { Grid } from '../Grid/Grid';
import { TextV2 } from '../TextV2/TextV2';
import { BooleanFilter } from 'utils/TypeUtils';

type BannerModuleProps = AppType.Component<{
  eyebrow?: string;
  headline: string;
  cta1?: Link;
  cta2?: Link;
  themeStyle: string;
  sticky: boolean;
}>;

export const BannerModule: React.FC<BannerModuleProps> = ({
  eyebrow,
  headline,
  cta1,
  cta2,
  themeStyle,
  sticky,
  ...props
}) => {
  const { t } = useTranslation();
  const [bannerClosed, setBannerClosed] = useState(false);
  const ctaLinks = [cta1, cta2].filter(BooleanFilter);

  const dismissBanner = () => {
    setBannerClosed(true);
  };

  const renderCTAs = () => (
    <>
      {ctaLinks?.map(
        (cta, index) =>
          cta && (
            <ButtonLinkV2
              key={cta.title}
              entry={toEntry(cta as WithCMS<Link>)}
              className={cx({ [styles.bannerFirstCta]: index === 0, [styles.bannerSecondCta]: index === 1 })}
              isFullWidth
              isButton
              size="small"
            />
          ),
      )}
    </>
  );

  return (
    <>
      {!bannerClosed && (
        <aside {...props._attributes} data-theme={themeStyle}>
          <Grid
            container
            justifyContent="center"
            className={cx({ [styles.bannerSticky]: sticky }, styles.banner)}
          >
            <button
              className={styles.bannerCloseButton}
              onClick={dismissBanner}
              aria-label={t('banner-module.alt-text-close-icon')}
            />
            <Grid item lg={6} md={12} sm={12} className={styles.bannerHeaderContainer}>
              {eyebrow && (
                <TextV2 className={styles.bannerEyebrow} value={eyebrow} variant="eyebrow" tagName="p" />
              )}
              {headline && (
                <TextV2
                  className={styles.bannerHeader}
                  value={headline}
                  variant="body-medium"
                  tagName="p"
                  isMarkdown
                />
              )}
            </Grid>
            {ctaLinks.length > 0 && (
              <Grid item lg={4} sm={12} className={styles.bannerCtaContainer}>
                {renderCTAs()}
              </Grid>
            )}
          </Grid>
        </aside>
      )}
    </>
  );
};

BannerModule.displayName = 'BannerModule';
